import { useEffect, useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Grid,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  Table,
  TableHead,
  TableRow,
  TableCell,
  IconButton,
  TableBody,
  Autocomplete,
  Checkbox,
  Chip,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import { Status } from '../../../../../themes/Global';


const CodingDetails = ({ modificar = {}, onSave}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [comments, setComments] = useState(modificar.ReleatedComments || []);
  const [openCommentDialog, setOpenCommentDialog] = useState(false);
  const [newComment, setNewComment] = useState('');
  const timestamp = new Date().toLocaleString(); 
  const [selectedOptions, setSelectedOptions] = useState(modificar.WelcomeCampaignOptions || []);
  const campaignOptions = ["CALL", "EMAIL", "TEXT", "VIDEO", "PENDING"];

  const [form, setForm] = useState({
    Update: modificar.Update,
    WelcomeCampaignOptions: modificar.WelcomeCampaignOptions,
    StaffName: modificar.StaffName,
    MemberID: modificar.MemberID,
    InsuranceStatus: modificar.InsuranceStatus,
    MemberFullName: modificar.MemberFullName,
    DOB: modificar.DOB,
    MemberEmail: modificar.MemberEmail,
    MemberPhoneNumber: modificar.MemberPhoneNumber, 
    MemberMobileNumber: modificar.MemberMobileNumber, 
    PCPFullName: modificar.PCPFullName,
    LastPCP: modificar.LastPCP,
    LastGroupName: modificar.LastGroupName, 
    Status: modificar.Status,
    OfficeLocation: modificar.OfficeLocation,
    ReleatedComments: modificar.ReleatedComments,
    TimeStamp: modificar.TimeStamp
  });

  const handleAddComment = () => {
    const timestamp = new Date().toLocaleString();
    const updatedComments = [...comments, { Timestamp: timestamp, Comments: newComment, StaffName: form.PCPFullName }];
    setComments(updatedComments);
    handleChange('ReleatedComments', updatedComments)
    setNewComment('');
    setOpenCommentDialog(false);
  };

  useEffect(()=>{
      setForm(prev => ({ ...prev, WelcomeCampaignOptions: selectedOptions }));
  },[selectedOptions]);

  const handleSave = () => {
    const envio = form;
    envio.Update = timestamp;
    onSave(envio);
  };

  const handleChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };

  return (
    <Container maxWidth="xl">
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5" fontWeight="bold">PCP Changes Detail</Typography>
        {!isEditing && (
          <Button variant="contained" startIcon={<EditIcon />} onClick={() => setIsEditing(true)}>Edit</Button>
        )}
      </Box>
      <Paper variant="outlined" sx={{ p: 4, mb: 3 }}>
        <Grid container spacing={2}>
            <Grid container spacing={2}>
              <Grid item width="100%"><Typography><strong>Member ID:</strong> {form.MemberID}</Typography></Grid>
              <Grid item width="100%"><Typography><strong>Insurance Status:</strong> {form.InsuranceStatus}</Typography></Grid>
              <Grid item width="100%"><Typography><strong>Member Full Name:</strong> {form.MemberFullName}</Typography></Grid>
              <Grid item width="100%"><Typography><strong>DOB:</strong> {form.DOB}</Typography></Grid>
              <Grid item width="100%"><Typography><strong>Member Phone Number:</strong> {form.MemberPhoneNumber}</Typography></Grid>
              <Grid item width="100%"><Typography><strong>PCP Full Name:</strong> {form.PCPFullName}</Typography></Grid>
              <Grid item width="100%"><Typography><strong>Office Location:</strong> {form.OfficeLocation}</Typography></Grid>
              <Grid item width="100%"><Typography><strong>Update:</strong> {form.Update}</Typography></Grid>
              <TextField
                disabled={!isEditing}
                label="Status"
                select
                fullWidth
                value={form.Status}
                onChange={e => handleChange('Status', e.target.value)}
              >
                {Status.map(opt => (
                  <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                ))}
              </TextField>
            </Grid>
        </Grid>
      </Paper>
      <Paper variant="outlined" sx={{ p: 4, mb: 3 }}>
        <Grid container spacing={2}>
            <Grid container spacing={2}>
              <Grid item width="100%"><Typography><strong>Welcome campaign Options:</strong></Typography></Grid>
               <Autocomplete
                  disabled={!isEditing}
                  fullWidth
                  multiple
                  options={campaignOptions}
                  disableCloseOnSelect
                  value={selectedOptions}
                  onChange={(event, newValue) => setSelectedOptions(newValue)}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        checked={selected}
                        style={{ marginRight: 8 }}
                      />
                      {option}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="Search"
                    />
                  )}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        key={option}
                        label={option}
                        {...getTagProps({ index })}
                        onClick={() => {}}
                      />
                    ))
                  }
                />
              <Grid item width="100%"><Typography><strong>Staff Name:</strong> {form.StaffName}</Typography></Grid>
              <Grid item width="100%"><Typography><strong>TimeStamp:</strong> {form.TimeStamp}</Typography></Grid>
            </Grid>
        </Grid>
      </Paper>

      {/* Related Comments */}
      <Paper variant="outlined" sx={{ p: 4, mb: 3 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="subtitle1" fontWeight="bold">Related Comments</Typography>
          {isEditing && (
            <IconButton color="primary" onClick={() => setOpenCommentDialog(true)}>
              <AddIcon />
            </IconButton>
          )}
        </Box>
        <Table size="medium">
          <TableHead>
            <TableRow>
              <TableCell><strong>Timestamp</strong></TableCell>
              <TableCell><strong>Comments</strong></TableCell>
              <TableCell><strong>Staff Name</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {comments.map((comment, idx) => (
              <TableRow key={idx} hover>
                <TableCell>{comment.Timestamp}</TableCell>
                <TableCell>{comment.Comments}</TableCell>
                <TableCell>{comment.StaffName}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
      {isEditing && (
          <Box display="flex" justifyContent="flex-end" sx={{ 
                mt: 2, // espacio arriba (theme spacing * 2 = 16px)
            }}>
            <Button variant="outlined" onClick={() => setIsEditing(false)}>Cancel</Button>
            <Button variant="contained" onClick={handleSave}>Save</Button>
          </Box>
        )}

      {/* Add Comment Dialog */}
      <Dialog open={openCommentDialog} onClose={() => setOpenCommentDialog(false)}>
        <DialogTitle>Add Comment</DialogTitle>
        <DialogContent>
          <TextField
            label="Comment"
            fullWidth
            multiline
            rows={4}
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenCommentDialog(false)}>Cancel</Button>
          <Button onClick={handleAddComment} variant="contained">Add</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default CodingDetails;
